$(document).ready(function () {

  $().fancybox({
    selector: '.lightbox:not(.slick-cloned)',
    animationEffect: 'fade',
    buttons: [
      'slideShow',
      // 'fullScreen',
      // 'thumbs',
      // 'share',
      // 'download',
      'zoom',
      'close',
    ],
    hash: false,
  });
});
